import appReducer from './appReducer'
import metaDataReducer from './metaDataReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import serviceAvailableReducer from './apiReducers/serviceAvailableReducer'
import processMasterNumberReducer from './apiReducers/processMasterNumberReducer'
import { combineReducers } from 'redux'
import confirmationReducer from './confirmationReducer';

const rootReducer = combineReducers({
  app: appReducer,
  confirmation: confirmationReducer,
  metaData: metaDataReducer,
  authentication: authenticationReducer,
  register: registerReducer,
  serviceAvailable: serviceAvailableReducer,
  vehicleDataAPI: processMasterNumberReducer
})

export default rootReducer
